import React from 'react'
import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react'
import { Article } from '@leid/api-articles'
import Link from 'next/link'

import { normalizeUrl } from 'utils/normalizeUrl'
import { trimStringToLength } from 'utils/trimStringToLength'

type Props = {
  article: Article
  link?: string
  href?: string
}

export const LimitedArticlePreview: React.FC<Props> = ({ article, link, href }) => {
  if (!article || !article.body) {
    return null
  }

  return (
    <Link
      as={link ? link : `/articles/${normalizeUrl(article.title ?? '', article.id)}`}
      href={href ? href : '/articles/[title]'}
    >
      <Flex>
        <Image
          objectFit="cover"
          width="98px"
          height="98px"
          borderRadius="9px"
          // TODO: Reimplement medium url
          src={article.image || '/article-big.png'}
          alt=""
        />
        <Box marginLeft="20px">
          <Heading as="h3" fontSize="md" color="black" fontWeight={500} lineHeight="24px">
            {article.title}
          </Heading>
          <Text fontSize="sm" color="#414C49" marginTop="6px" lineHeight="18px" fontWeight={300}>
            {trimStringToLength(article.body.replace(/<[^>]*>/g, ' ').replace(/<img .*?>/g, ''), 75)}
          </Text>
        </Box>
      </Flex>
    </Link>
  )
}
